import React from 'react';
import {Button} from '@xpertdox_js/xdcomponents';
import { trackActivity } from '../../utils/activityTracker'
import { UserContext } from '../../Context/UserContext'
import { InstanceContext } from '../../InstanceContext'


const BroadcastButton = props => {
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const handleClick = () => {
    props.controller.handleGroupAction({actionID: 'emailBroadcast'});
    handleActivityLogUpdate(`BroadcastButton.handleClick`)

  }
  const styles = {
    clear: 'both',
    background: '#2C81D2',
    color: '#fff',
    borderRadius: '2px',
    opacity: .9,
    boxShadow: '0 2px 6px rgba(0,0,0,0.24)',
    hover: {
      opacity: 1,
      boxShadow: '0 2px 12px rgba(0,0,0,0.24)',
    },
    borderBottom: '2px solid rgba(0,0,0,0.2)',
    backgroundVisibility: 'hidden',
    transition: 'opacity .2s, box-shadow .32s',
    // animation: 'zoom-in .32s',
    fontSize: '18px'
  }

  const svg = {
    display: 'block',
    width: '24px',
    height: '24px',
    // height: 'auto',
    float: 'left',
    fill: '#fff',
    marginRight: '8px'
  }

  return(
    <Button
      onClick={handleClick}
      styles={styles}
      hoverStyles={styles.hover}
      activeStyles={styles.active}
    >
      <svg style={svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M435.9 64.9l-367.1 160c-6.5 3.1-6.3 12.4.3 15.3l99.3 56.1c5.9 3.3 13.2 2.6 18.3-1.8l195.8-168.8c1.3-1.1 4.4-3.2 5.6-2 1.3 1.3-.7 4.3-1.8 5.6L216.9 320.1c-4.7 5.3-5.4 13.1-1.6 19.1l64.9 104.1c3.2 6.3 12.3 6.2 15.2-.2L447.2 76c3.3-7.2-4.2-14.5-11.3-11.1z"/></svg>
      <span>New Email Broadcast</span>
    </Button>
  )
}

export default BroadcastButton;
